import React, { FC, ReactNode } from 'react'

import { css, cx } from '@linaria/core'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { hideTooltipsAction } from 'actions/tooltipAction'
import { SharingMethod } from 'api/sharingContentApi'
import { MenuIcon } from 'components/designSystem/MenuIcon/MenuIcon'
import viberSvg from 'components/designSystem/svg/viber.svg'
import whatsappSvg from 'components/designSystem/svg/whatsapp.svg'
import { ShareSvg } from 'components/designSystem/svgr/ShareSvg'
import { SharingMethodSocialMap } from 'reducers/sharing/sharing.function'

import { sharingMethodClipBoard } from './SharingContent.constant'
import { SharingContentProps } from './SharingContent.types'
import { copyToClipboard } from '../../../../client/functions/copyToClipboard'

const messages: Record<string, Record<string, string>> = defineMessages({
  url: { id: 'sharing.text.url', defaultMessage: 'Скопировать ссылку' },
})

const iconList: Record<string, ReactNode> = {
  url: <ShareSvg />,
  whatsapp: whatsappSvg,
  viber: viberSvg,
}

export const SharingContentNextView: FC<SharingContentProps> = ({
  sharingMethods,
  fetchUniNoticeAction,
  shareHitMethodStatisticsAction,
  callbackHandler,
}) => {
  const dispatch = useDispatch()
  const intl = useIntl()

  const handleShare = (sharingObject: SharingMethod) => {
    if (sharingObject.sharingMethod === sharingMethodClipBoard) {
      if (fetchUniNoticeAction) {
        fetchUniNoticeAction()
      }

      copyToClipboard(sharingObject.url)
    }

    if (shareHitMethodStatisticsAction) {
      shareHitMethodStatisticsAction(sharingObject.sharingMethod)
    }

    /** Так как компонент используются как в bottomSheet так и popover оставляем оба action для закрытия */
    dispatch(hideTooltipsAction())
    callbackHandler?.()
  }

  return (
    <>
      {sharingMethods.map((item) => {
        if (item.sharingMethod === sharingMethodClipBoard) {
          return (
            <MenuIcon
              key={item.sharingMethod}
              data-name={`sharing-method-${item.sharingMethod}-action`}
              onClick={() => handleShare(item)}
              className={cx(menuCss)}
              hasBackground={true}
              icon={iconList['url']}
              text={intl.formatMessage(messages['url'])}
              fontSize={16}
              fontWeight={500}
              tag="div"
            />
          )
        }

        return (
          <MenuIcon
            key={item.sharingMethod}
            data-name={`sharing-method-${item.sharingMethod}-action`}
            onClick={() => handleShare(item)}
            className={cx(menuCss)}
            hasBackground={true}
            icon={iconList[item.sharingMethod]}
            iconType="image"
            text={SharingMethodSocialMap[item.sharingMethod].title}
            fontSize={16}
            fontWeight={500}
            href={item.url}
            tag="div"
            externalHref={Boolean(item.url)}
          />
        )
      })}
    </>
  )
}

const menuCss = css`
  padding: var(--spacing-16px) 0;
  cursor: pointer;
`
